"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentWidth = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var getWidth = function getWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

/**
 * Use this hook to get changes in viewport width. Useful when trying to
 * to implement responsiveness.
 *
 * @returns {number}
 */
var useCurrentWidth = exports.useCurrentWidth = function useCurrentWidth() {
  var _useState = (0, _react.useState)(getWidth()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  (0, _react.useEffect)(function () {
    var resizeListener = function resizeListener() {
      setWidth(getWidth());
    };
    window.addEventListener('resize', resizeListener);
    return function () {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);
  return width;
};